import React, { SVGProps, useId } from 'react'
import { useTheme } from 'styled-components'

type Props = SVGProps<SVGSVGElement> & {
  animationInterval?: number
  height: number
  id?: string
  width: number
}

export const Skeleton = ({
  children,
  width,
  height,
  animationInterval = 2,
  id: propId,
  ...props
}: Props) => {
  const defaultId = useId()
  const id = propId ?? defaultId
  const { colors } = useTheme()
  return (
    <svg
      role='img'
      width={width}
      height={height}
      aria-labelledby='loading-aria'
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio='none'
      {...props}
    >
      <title id='loading-aria'>loading</title>
      <rect
        x='0'
        y='0'
        width='100%'
        height='100%'
        clipPath={`url(#clip-path-${id})`}
        style={{ fill: `url("#fill-${id}")` }}
      />
      <defs>
        <clipPath id={`clip-path-${id}`}>{children}</clipPath>
        <linearGradient id={`fill-${id}`}>
          <stop offset='0.599964' stopColor={colors['bg/skeleton-background']} stopOpacity='1'>
            <animate
              attributeName='offset'
              values='-2; -2; 1'
              keyTimes='0; 0.25; 1'
              dur={`${animationInterval}s`}
              repeatCount='indefinite'
            />
          </stop>
          <stop offset='1.59996' stopColor={colors['bg/skeleton-flicker']} stopOpacity='1'>
            <animate
              attributeName='offset'
              values='-1; -1; 2'
              keyTimes='0; 0.25; 1'
              dur={`${animationInterval}s`}
              repeatCount='indefinite'
            />
          </stop>
          <stop offset='2.59996' stopColor={colors['bg/skeleton-background']} stopOpacity='1'>
            <animate
              attributeName='offset'
              values='0; 0; 3'
              keyTimes='0; 0.25; 1'
              dur={`${animationInterval}s`}
              repeatCount='indefinite'
            />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  )
}
